<div class="flex align-middle text-base font-normal" [ngClass]="{ 'opacity-60': disabled }">
  <input
    class="peer sr-only"
    #input
    type="checkbox"
    [id]="inputId"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    (blur)="onBlur()"
    (click)="onInputClick()"
    (change)="onInteractionEvent($event)"
  />
  <div (click)="onTouchTargetClick()" [ngClass]="checkboxClasses">
    <div class="relative size-4 shrink-0 select-none rounded-base border border-solid border-grey-300">
      @if (checked || indeterminate) {
        <sb-icon
          class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          [size]="'sm'"
          [name]="indeterminate ? 'minus' : 'check'"
        />
      }
    </div>
  </div>

  <label
    [for]="inputId"
    #label
    [ngClass]="{ truncate: truncateLabel }"
    class="m-0 grow cursor-pointer pl-1.5 empty:hidden empty:select-none peer-disabled:cursor-default peer-aria-invalid:text-danger"
    ><ng-content></ng-content
  ></label>
</div>
